module.exports = __webpack_public_path__ + "img/身份验证后.f10b44d8.png";